<template>
    <div class="Background">
        <v-container fluid>
        <v-row no-gutters class="uniform-gap-32">
            <!-- 좌측 컬럼: 플레이어 + 소셜미디어 -->
            <v-col
                cols="12" md="7" xl="8" class="grid-col"
            >
            <!-- 플레이어 카드 -->
            <div class="video-container mb-4">
                <iframe
                    scrolling="no"
                    ref="iframe"
                    :src="EMBEDIEDURL"
                    frameborder="0"
                    allowfullscreen
                    @load="temp"
                    @playing="resizeVideo"
                ></iframe>
            </div>

            <!-- 플레이어 아래 새로고침/안내 -->
            <v-alert class="info_alert" type="info" dense text>
                <span>{{ $store.getters.t('새로고침 버튼을 눌러주셔야 라이브 방송이 스트림온에 반영됩니다.') }}</span>
                <template v-slot:append>
                    <v-btn small icon color="blue darken-2" @click="refreshIframe">
                    <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </template>
            </v-alert>

            </v-col>

            <!-- 우측 컬럼: 스트리밍 상세 정보 + URL INFO -->
            <v-col
            cols="12" md="5" xl="4" class="grid-col"
            >
            <!-- 스트리밍 상세 정보 -->
            <v-card class="rounded-lg elevation-0 mb-6">
                <v-card-title class="py-4 d-flex justify-space-between py-4">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('스트리밍 상세 정보') }}</h3>
                    <div>
                        <TextButton :buttonText="$store.getters.t('목록')" @click="goLiveList()" class="mr-2"/>
                        <TextButton :buttonText="$store.getters.t('저장')" isPrimary @click="saveChanges" :loading="saveLoading"/>
                    </div>
                    </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                            {{ $store.getters.t('Live 스트리밍') }}
                        </th>
                        <th class="thead_custom_right thead_custom_top pa-3">
                            <span>
                            <Input placeholder="name" :value="displayStreamName" viewType="name" :disabled="true" />
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('Live 송출') }}
                        </th>
                        <th class="thead_custom_right pa-3">
                            <span v-if="livestatus === 1" class="reco_status recording_on">
                                <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                                {{ $store.getters.t('라이브 송출 중입니다.') }}
                            </span>
                            <span v-if="livestatus === 0" class="reco_status recording_off">
                                <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                                {{ $store.getters.t('라이브 중이 아닙니다.') }}
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('레코딩') }}
                        </th>
                        <th class="thead_custom_right pa-3" style="display:flex;align-items:center;">
                            <CustomSwitch :switchState="switchStates.recording" :toggleSwitch="() => toggleSwitch('recording')" />
                            <span v-if="recorderState === 'stop'" class="reco_status recording_off">
                            <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                            {{ $store.getters.t('녹화 중이 아닙니다') }}
                            </span>
                            <span v-if="recorderState === 'progress'" class="reco_status recording_on">
                            <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                            {{ $store.getters.t('녹화 중입니다') }}
                            </span>
                            <span v-if="recorderState === 'wait'" class="reco_status recording_waiting">
                            <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                            {{ $store.getters.t('영상을 준비하는 중입니다') }}
                            </span>
                        </th>
                        </tr>
                    </thead>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>

            <!--보안옵션-->
            <v-card class="rounded-lg elevation-0 mb-6" v-if="appType == 'secure'" >
                <v-card-title class="py-4 d-flex justify-space-between py-4">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('보안 옵션') }}</h3>
                    <div class="text-right">
                        <TextButton :buttonText="$store.getters.t('플레이어 다운로드')" iconColor="#555" icon="mdi mdi-download" class="ml-2" small @click="downloadCode"/>
                        <TextButton :buttonText="$store.getters.t('코드 보기')" iconColor="#555" icon="mdi mdi-xml" class="ml-2" small @click="openCode"/>
                    </div>
                </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">
                <v-simple-table>
                    <template v-slot:default>
                    <thead>
                        <tr>
                        <th class="thead_custom_left thead_custom_top pa-3" style="height: 60px;">
                            {{ $store.getters.t('Domain') }}
                        </th>
                        <th class="thead_custom_right thead_custom_top pa-3">
                            <span>
                                <input v-model="domain" class="mt-2 search-input"/>
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('Private Key') }}
                        </th>
                        <th class="thead_custom_right pa-3">
                            <span>
                                <input v-model="privateKey" class="mt-2 search-input"/>
                            </span>
                        </th>
                        </tr>
                        <tr>
                        <th class="thead_custom_left pa-3" style="height: 66px;">
                            {{ $store.getters.t('레코딩') }}
                        </th>
                        <th class="thead_custom_right pa-3" style="display:flex;align-items:center;">
                            <CustomSwitch :switchState="switchStates.recording" :toggleSwitch="() => toggleSwitch('recording')" />
                            <span v-if="recorderState === 'stop'" class="reco_status recording_off">
                            <v-icon x-small class="mdi mdi-square mr-1" color="#999" />
                            {{ $store.getters.t('녹화 중이 아닙니다') }}
                            </span>
                            <span v-if="recorderState === 'progress'" class="reco_status recording_on">
                            <v-icon x-small class="mdi mdi-circle mr-1 blinking" color="#d33333" />
                            {{ $store.getters.t('녹화 중입니다') }}
                            </span>
                            <span v-if="recorderState === 'wait'" class="reco_status recording_waiting">
                            <v-icon small class="mdi mdi-clock-outline mr-1" color="#d33333" />
                            {{ $store.getters.t('영상을 준비하는 중입니다') }}
                            </span>
                        </th>
                        </tr>
                    </thead>
                    </template>
                </v-simple-table>
                </v-card-text>
            </v-card>

            <!-- URL INFO -->
            <v-card class="rounded-lg elevation-0">
                <v-card-title class="py-4 d-flex justify-space-between align-center">
                    <h3 class="tabletitle pb-0">{{ $store.getters.t('INFO') }}</h3>
                </v-card-title>
                <v-divider />

                <v-card-text class="pt-4">

                <!-- URL 항목들 -->
                <div class="url-info-list">

                    <!-- Pull URL -->
                    <div class="url-block">
                        <div class="url-label">{{ $store.getters.t('Pull URL') }}</div>
                        <div class="url-line">
                        <div class="url-text mono-ellipsis" :title="OnpublishServer">{{ OnpublishServer }}</div>
                        <v-btn icon color="#999" @click="copyToClipboard(OnpublishServer)">
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        </div>
                    </div>

                    <!-- StreamKey -->
                    <div class="url-block">
                        <div class="url-label">{{ $store.getters.t('StreamKey') }}</div>
                        <div class="url-line">
                        <div class="url-text mono-ellipsis" :title="stream_name">{{ stream_name }}</div>
                        <v-btn icon color="#999" @click="copyToClipboard(stream_name)">
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        </div>
                    </div>

                    <!-- Embedded URL -->
                    <div class="url-block">
                        <div class="url-label">{{ $store.getters.t('EMBEDDED URL') }}</div>
                        <div class="url-line">
                        <div class="url-text mono-ellipsis" :title="EMBEDIEDURL">{{ EMBEDIEDURL }}</div>
                        <v-btn icon color="#999" @click="copyToClipboard(EMBEDIEDURL)">
                            <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                        </div>
                    </div>

                </div>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
    </v-container>

    <!-- 스낵바 -->
    <AppSnackbar :message="snackbarText" :visible="snackbar" :error="snackbarError" />
    
    <AppDialogLarge width="950px" v-model="modalOpen" :persistent="true">
        <template v-slot:title>
            <span class="social_title">{{ $store.getters.t('Player Sample Code') }}</span>
        </template>
        <template v-slot:close>
            <v-btn icon @click="modalOpen = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </template>
        <template v-slot:content>
            <div class="code-box">
                <pre><code style="background-color: none !important; ">{{ previewHtml }}</code></pre>
            </div>
            <TextButtonBlock :buttonText="$store.getters.t('닫기')" :width="'49.5%'" @click="modalOpen = false"/>
            <TextButtonBlock :buttonText="$store.getters.t('복사하기')"  @click="copyToClipboardHTML(previewHtml)" :width="'49.2%'" class="ml-2" />
        </template>
    </AppDialogLarge>

</div>

</template>



<script>
import Input from '@/components/ui/form/FormInput.vue';
// import TextButton from '@/components/ui/button/TextButton2.vue';
import TextButton from '@/components/ui/button/TextButton.vue';
import CustomSwitch from '@/components/ui/switch/CustomSwitch.vue';
import IconButton from '@/components/ui/button/IconButton.vue';
import WebRtcStreamApi from "@/api/webrtc/WebRtcStreamApi";
import { mapActions, mapState } from 'vuex';
import livestatus from '@/store/modules/livestatus';
import AppSnackbar from "@/components/ui/snackbar/Snackbar.vue";
import TextButtonBlock from '@/components/ui/button/TextButtonBlock.vue';
import AppDialogLarge from '@/components/app/AppDialogLarge.vue';
import { getDisplayStreamName } from '@/utils/streamName';

export default {
    components: {
        Input,
        TextButton,
        CustomSwitch,
        IconButton,
        AppSnackbar,
        AppDialogLarge,
        TextButtonBlock
    },
    data() {
        return {
            info: [],
            // switchStates: {
            //     publishing: false,
            //     recording: false,
            // },
            recorderState: '',
            snackbar: false,
            snackbarText: '',
            snackbarError: false,
            privateKey: null,
            // validTime: null,
            modalOpen: false,
            domain: '',
            previewHtml: '',
            appType: '',
            saveLoading: false,
        }
    },
    computed: {
        ...mapState('livestatus', {
            switchStates: state => state.switchStates
        }),
        EMBEDIEDURL() {
            if(this.info){
                return this.info.play_url;
            } else {    
                return null;
            }
        },
        OnpublishServer() {
            if(this.info){
                return this.info.publish_url;
            } else {    
                return null;
            }
        },
        isRecording() {
            if(this.info){
                return this.info.record;
            } else {    
                return null;
            }
        },
        displayStreamName() {
            const info = this.info || {};
            return getDisplayStreamName(info.stream_name_by_user, info.stream_name);
        },
        stream_name(){
            if(this.info){
                return this.info.stream_name;
            } else {    
                return null;
            }
        },
        // ThumbnailUrl(){
        //     if(this.info){
        //         return this.info.thumb;
        //     } else {
        //         return null;
        //     }
        // },
        livestatus(){
            if(this.info){
                return this.info.live_status;
            } else {
                return null;
            }
        }
    },
    methods: {
        async openCode() {
            const uuid = this.$route.params.uuid;
            const params = {
                uuid: uuid
            }
            const response = await WebRtcStreamApi.previewApi(params);
          
            this.previewHtml = response.html;
            this.modalOpen = true;
        },
        async downloadCode(){
            const uuid = this.$route.params.uuid;
            const params = {
                uuid: uuid
            }
            const response = await WebRtcStreamApi.previewApi(params);
          
            this.previewHtml = response.html;
            
            const blob = new Blob([this.previewHtml], { type: 'text/html' });
            const url = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            // a.download = 'player.html';
            a.download = 'player.php';
            a.click();

            URL.revokeObjectURL(url);
            
            // const blob = new Blob([this.previewHtml], { type: 'text/html' });
            // const url = URL.createObjectURL(blob);

            // const a = document.createElement('a');
            // a.href = url;
            // a.download = 'player.html';
            // a.click();

            // URL.revokeObjectURL(url);
        },
        async saveChanges(){
            this.saveLoading = true;

            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const uuid = this.$route.params.uuid;
            const data = {
                ip: frontUrl,
                uuid: uuid,
                domain: this.domain,
                privateKey: this.privateKey,
                // validTime: this.validTime
            };

            const res = await WebRtcStreamApi.savePullInfo(data);

            if(res.status == 1){
                this.saveLoading = false;
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('정보 수정에 성공했습니다.');
                this.snackbarError = false;

                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = '';
                }, 2000);

            } else {
                this.saveLoading = false;
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('정보 수정에 실패했습니다.');
                this.snackbarError = true;

                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = '';
                }, 2000);
            }
        },
        goLiveList(){
            this.$router.push('/webrtc/stream_create');
        },
        copyToClipboard(textToCopy) {

            if(!textToCopy){
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('복사할 텍스트가 없습니다.');
                this.snackbarError = true;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarError = false;
                    this.snackbarText = "";
                }, 2000);

                return;
            }

            this.$copyText(textToCopy)
                .then(() => {
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('텍스트가 복사되었습니다');
                    this.snackbarError = false;
                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = "";
                    }, 2000);
                })
                .catch(() => {
                    alert('Failed to copy text.');
                });
        },
        async copyToClipboardHTML(textToCopy) {
            try {
                await navigator.clipboard.writeText(textToCopy);
                this.snackbar = true;
                this.snackbarText = this.$store.getters.t('텍스트가 복사되었습니다');
                this.snackbarError = false;
                setTimeout(() => {
                    this.snackbar = false;
                    this.snackbarText = "";
                }, 2000);
            } catch (err) {
                alert('Failed to copy text.');
            }
        },
        refreshIframe() {
            this.refresh();
            const originalURL = this.EMBEDIEDURL;
            this.$refs.iframe.src = '';
            this.$nextTick(() => {
                this.$refs.iframe.src = originalURL;
                const video =  this.$refs.iframe.contentWindow.document.querySelector('video');
                video.autoplay = true;
                video.play();
            });
        },
        async liveData(uuid) {
            try {
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                };
                const response = await WebRtcStreamApi.detailApi(data);
                if(response.status == 1) this.info = response.data;

                this.switchStates.recording = this.info.record_status == "1";
                this.privateKey = this.info.private_key;
                // this.validTime = this.info.valid_time;
                this.domain = this.info.domain ?? null;
                this.appType = this.info.appType;

                // console.log("info => ", this.info)

            } catch (error) {
                console.error('error', error);
            }
        },
        temp() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            if (!video) return;
            video.poster = "/streamon.png";
        },
        resizeVideo() {
            const iframe = this.$refs.iframe;
            const video = iframe.contentWindow.document.querySelector('video');
            const iframeDocument = iframe.contentWindow.document;
            if (!video) return;

            const container = iframe.parentElement;
            const containerWidth = container.offsetWidth;
            const videoWidth = video.videoWidth;
            const videoHeight = video.videoHeight;
            const aspectRatio = videoWidth / videoHeight;

            if (aspectRatio < 1) {
                container.style.paddingBottom = `${(videoHeight / videoWidth) * 100}%`;
            } else {
                container.style.paddingBottom = '56.25%';
            }

            video.autoplay = true;
            video.play();

        },
        refresh() {
            const uuid = this.$route.params.uuid;
            this.liveData(uuid);
        },
        // toggleSwitch(switchKey) {
        //     this.switchStates[switchKey] = !this.switchStates[switchKey];
        // }
        async toggleSwitch(switchKey) {
            try {
                const newState = this.switchStates[switchKey] = !this.switchStates[switchKey];
                let response;
                // console.log("확인 => ", this.switchStates.recording)
                const frontUrl = `${window.location.protocol}//${window.location.host}`;
                const uuid = this.$route.params.uuid;
                const data = {
                    ip: frontUrl,
                    uuid: uuid,
                    recording: newState,
                    // stream_name: this.stream_name
                };
                if (switchKey === 'recording') {
                    response = await this.$store.dispatch('livestatus/saveSettingsWebRTC', data);
                }

                if (response) {
                    this.$emit('settingsSaved');
                    this.snackbar = true;
                    this.snackbarText = this.$store.getters.t('정보 수정에 성공했습니다.');
                    this.snackbarError = false;

                    setTimeout(() => {
                        this.snackbar = false;
                        this.snackbarText = '';
                    }, 2000);
                }
            } catch (error) {
                console.error('Error', error);
            }
        },
        async updateRecordingStatus(newState) {
            // console.log('recording');
            // const data = { streamName: this.stream_name, status: newState ? 1 : 0, application: this.application };
            // return await LiveStreamApi.updateRecordingOnOffApi(data);
            const frontUrl = `${window.location.protocol}//${window.location.host}`;
            const uuid = this.$route.params.uuid;
            const data = {
                ip: frontUrl,
                uuid: uuid,
                recording: this.switchStates ? this.switchStates.recording : false,
            };
            return await WebRtcStreamApi.saveStreamApi(data);

        },
        async pullStatus() {
            try {
                const data = {
                    recorderName: this.stream_name,
                    application: this.application
                }
                const response = await LiveStreamApi.checkStatus(data);
                if (response.status === '1') {
                    //레코딩 상태는 on이지만 영상재생에 따른 상태
                    if (response.recorderState === 'Waiting for stream') {
                        this.recorderState = 'wait';
                        this.switchStates.recording = false;
                    } else if (response.recorderState === 'Recording in Progress') {
                        this.recorderState = 'progress';
                        this.switchStates.recording = true;
                    } else {
                        this.recorderState = 'stop';
                        this.switchStates.recording = false;
                    }
                } else if (response.status === '2') {
                    // recorder not found일 때
                    this.recorderState = 'stop';
                    this.switchStates.recording = false;
                }

            } catch (error) {
                console.error('Error', error);
            }
        },

    },
    async beforeMount() {
        const uuid = this.$route.params.uuid;
        await this.liveData(uuid);
        // this.pullStatus();
    },
    watch: {
        'switchStates.publishing'(newVal) {
            if (newVal) {
                this.refreshIframe();
                // this.pullStatus();
            }
        }
    }
}
</script>

<style>
.cont_title {
    margin-top: 20px;
    padding-bottom: 10px;
    border-bottom: 1px solid #000;
    font-size: 18px;
}

.tabletitle {
    font-size: 18px;
    padding-bottom: 10px;
}

.left_wraper {
    width: 800px !important;
}

@media only screen and (max-width: 600px) {
    .lr_wrapper {
        display: block;
    }

    .right_wraper {
        margin: 0px;
    }
}

.right_wraper {
    width: 100%;
    margin-left: 20px;
}

.text_box {
    word-break: break-all;
    color: #888;
    width: 100%;
}

/* .text-left {} */

.table_text {
    background: #fff;
}

iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.Live-video-container video {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.Live-video-container {
    position: relative;
    background-color: black;
    width: 100%;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 12px;
}

.thumbnail-wrapper {
    position: relative;
    width: 300px;
    height: 200px;
}

.thumbnail-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.reco_status {
    line-height: 14px;
    margin-left: 10px;
    padding: 4px 8px 4px 8px;
    border-radius: 2px;
}

.reco_status.recording_on {
    background: #ffe7e7;
    color: #d33333;
}

.reco_status.recording_off {
    background: #f4f4f4;
    color: #696969;
}

.reco_status.recording_waiting {
    background: #fff5df;
    color: #e69b3f;
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

.blinking {
    animation: blink 1.3s infinite;
}

.code-box {
  background-color: #f5f5f5;       /* 은은한 회색 배경 */
  border: 1px solid #e0e0e0;       /* 얇은 테두리 */
  border-radius: 6px;
  padding: 12px 16px;
  font-family: 'Fira Code', 'Consolas', 'Courier New', monospace; /* 코드 폰트만 지정 */
  max-height: 300px;               /* 높이 제한 */
  overflow-y: auto;                /* 세로 스크롤 */
  line-height: 1.6;
  white-space: pre-wrap;           /* 줄바꿈 유지 */
  word-break: break-all;           /* 긴 코드 자동 줄바꿈 */
  white-space: pre-wrap;  /* 줄바꿈 허용 */
  word-break: break-word; /* 단어 단위 줄바꿈 */
  overflow-x: hidden; 
  margin-bottom: 18px;
}

.code-box pre,
.code-box code,
.code-box pre code,
.theme--light .code-box code,
.theme--dark .code-box code,
.hljs, .code-box .hljs {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
}

.code-box::-webkit-scrollbar {
  width: 8px;               /* 스크롤바 두께 */
  background: transparent;  /* 스크롤 트랙 배경 없음 */
}

.code-box::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;  /* 스크롤 핸들 색상 (연한 회색) */
  border-radius: 4px;         /* 둥근 모양 */
  
}

.code-box::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;  /* hover 시 조금 더 진하게 */
}

.code-box::-webkit-scrollbar-button {
  display: none;  /* 🔹 위/아래 버튼 숨김 */
}
</style>
